<template>
  <v-container fluid class="fontosak hirlista-oldal">
    <div class="page-content">
      <div class="flex-center-between">
        <v-btn
          icon
          large
          color="primary"
          class="back-btn"
          @click="$goBackTo({ name: 'Fooldal' })"
        >
          <i class="fas fa-chevron-left"></i>
        </v-btn>
        <k-hamburger-icon class="back-btn" v-if="isMobile"></k-hamburger-icon>
      </div>
      <h2>Fontosak</h2>
      <k-hir-lista :getHirek="GetHirek()" :headerHeight="107">
        <k-nodata-info>
          <template v-slot:icon>
            <i class="fas fa-bookmark"></i>
          </template>
          <template v-slot:text>
            {{ nyelvesites['nincs_mentett_cikk_text'] }}
          </template>
        </k-nodata-info>
      </k-hir-lista>
      <img
        v-if="isBv"
        src="../assets/images/bv-logo-zold.png"
        class="bv-logo-green"
      />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import settings from '../settings';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'Fontosak',
  data() {
    return {
      tab: null,
      isBv: settings.env == 'bv',
    };
  },
  mounted() {},
  created() {},
  methods: {
    GetHirek(kategoriaId) {
      return utolsoHir => {
        return hirService.GetFontosHirek({
          kategoriaId: kategoriaId,
          utolsoHirId: utolsoHir?.Id,
        });
      };
    },
  },
  computed: {
    ...mapGetters({
      hirKategoriak: AppStoreTypes.hirKategoriak.getAll,
      user: AppStoreTypes.user.get,
    }),
    tabUpdate() {
      return [this.hirKategoriak.length, this.routeHirKategoriaId].join('_');
    },
    routeHirKategoriaId() {
      return this.$route.params.id;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
  },
  watch: {
    tabUpdate: {
      handler(v) {
        let routeHirKategoriaId = this.routeHirKategoriaId;
        let idx = this.hirKategoriak.findIndex(
          f => f.Id == routeHirKategoriaId
        );
        if (idx) {
          this.tab = idx;
        }
      },
      immediate: true,
    },
  },
  components: {},
};
</script>
